export class SearchController {
  constructor(controller) {
    this.controller = controller
  }

  // ========================================
  // 検索処理
  // ========================================

  onSearchClick(event) {
    event.preventDefault()

    const prefecture = this.controller.selectedPrefecture
    const city = this.controller.selectedCity

    // チェックされた部位を全て取得
    const checkedPartTypes = this.controller.partTypeTargets.filter(checkbox => checkbox.checked)

    // 都道府県が選択されていない場合はエラー
    if (!prefecture) {
      alert('都道府県を選択してください')
      return
    }

    // URL生成ロジック
    let url = `/area/${encodeURIComponent(prefecture)}`

    if (city) {
      url += `/${city}`
    }

    // 複数の部位をクエリパラメータに追加
    if (checkedPartTypes.length > 0) {
      const params = checkedPartTypes.map(checkbox =>
        `part_types%5B%5D=${encodeURIComponent(checkbox.value)}`
      ).join('&')
      url += `?${params}`
    }

    // ページ遷移
    window.location.href = url
  }
}
